// Impostazioni → Mutui: i parametri dei prospetti di sostenibilità. **Solo admin** (la rotta risponde 403 a
// tutti gli altri: backend/mutui.py).
//
// Sono **valori indicativi**, scelti da noi, non regole di nessuna banca: accanto a ognuno c'è scritto, perché
// chi li legge fra sei mesi non li scambi per dati ufficiali. Cambiarli aggiorna tutti i prospetti, anche quelli
// vecchi: il risultato non è salvato da nessuna parte, si rifà ogni volta (backend/calcolo_mutuo.py).
//
// Il tasso **non è un parametro**: lo pubblica mkconsulting.it e lo legge il server. Qui c'è solo la scappatoia
// del valore manuale, per il giorno in cui serve provare un tasso diverso da quello di mercato.
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import { errore } from '../scheda/comuni';

// Le spese di vita non sono più parametri: dal 16/10/2026 la rata è solo rapporto rata/reddito meno i prestiti.
// I vecchi valori possono essere ancora nel database: il server li ignora e questa pagina non li manda più.
const CAMPI = ['soglia_rata_reddito', 'ltv_massimo', 'eta_massima_fine_mutuo', 'avviso_tasso_giorni'];
const testo = (v) => (v === null || v === undefined ? '' : String(v).replace('.', ','));
const numero = (v) => (String(v).trim() === '' ? null : Number(String(v).replace(',', '.')));
const daDati = (d) => ({ ...Object.fromEntries(CAMPI.map((k) => [k, testo(d[k])])), tasso_manuale: testo(d.tasso_manuale) });

const ORIGINE = {
  sito: 'dal calcolatore di mkconsulting.it',
  riserva: 'ultimo valore letto dal sito (adesso non risponde)',
  manuale: 'valore manuale scritto qui sotto',
  assente: 'non disponibile: il sito non risponde e non ne abbiamo uno da prima',
};

const Mutui = () => {
  const [dati, setDati] = useState(null);
  const [form, setForm] = useState(null);
  const [salvo, setSalvo] = useState(false);

  const carica = () => axios.get(`${API}/mutui/impostazioni`)
    .then((r) => { setDati(r.data); setForm(daDati(r.data)); })
    .catch(errore);
  useEffect(() => { carica(); }, []);

  const salva = async (valori) => {
    setSalvo(true);
    try {
      const r = await axios.put(`${API}/mutui/impostazioni`, valori);
      setDati(r.data); setForm(daDati(r.data));
      toast.success('Salvato');
    } catch (e) { errore(e); } finally { setSalvo(false); }
  };

  if (!form) return null;
  const cambiato = JSON.stringify(form) !== JSON.stringify(daDati(dati));
  const perIlServer = () => ({
    ...Object.fromEntries(CAMPI.map((k) => [k, numero(form[k])])),
    tasso_manuale: form.tasso_manuale.trim() === '' ? null : numero(form.tasso_manuale),
  });
  const tasso = dati.tasso || {};

  return (
    <section className="card" data-testid="impostazioni-mutui">
      <div className="ttl"><h2>Mutui <small>prospetti di sostenibilità</small></h2></div>

      <div className="imp-tasso" data-testid="tasso-impostazioni">
        <b>Tasso di riferimento</b>
        <span>{ORIGINE[tasso.origine] || '—'}</span>
        {Object.keys(tasso.per_durata || {}).length > 0 && (
          <div className="imp-durate">
            {Object.entries(tasso.per_durata).map(([anni, valore]) => (
              <span key={anni}>{anni} anni <b>{String(valore).replace('.', ',')}%</b></span>
            ))}
          </div>
        )}
        {tasso.aggiornato_il && <small>aggiornato il {tasso.aggiornato_il.split('-').reverse().join('/')}</small>}
        {tasso.avviso && <small className={tasso.vecchio || tasso.origine === 'assente' ? 'grave' : undefined}>{tasso.avviso}</small>}
      </div>

      <div className="imp-righe pesi">
        {CAMPI.map((chiave) => (
          <div key={chiave}>
            <div>
              <span className="nome-peso">{dati.nomi[chiave]}</span>
              <small>di base {dati.predefiniti[chiave]} · valore indicativo, modificabile</small>
            </div>
            <input className="imp-input" style={{ width: "7rem" }} inputMode="numeric" value={form[chiave]} aria-label={dati.nomi[chiave]}
              onChange={(e) => setForm({ ...form, [chiave]: e.target.value })} />
          </div>
        ))}
        <div>
          <div>
            <span className="nome-peso">Valore manuale del tasso (%)</span>
            <small>vuoto: vale il tasso del sito, uno per durata. Scritto: vince su tutte le durate.</small>
          </div>
          <input className="imp-input" style={{ width: "7rem" }} inputMode="decimal" value={form.tasso_manuale} aria-label="Valore manuale del tasso"
            placeholder="vuoto" onChange={(e) => setForm({ ...form, tasso_manuale: e.target.value })} />
        </div>
      </div>

      <div className="imp-azioni">
        <button type="button" className="btn sm p" disabled={!cambiato || salvo} onClick={() => salva(perIlServer())}>
          {salvo ? 'Salvo…' : 'Salva'}
        </button>
        <button type="button" className="btn sm" disabled={salvo} onClick={() => salva({ ...dati.predefiniti, tasso_manuale: null })}>
          Valori di base
        </button>
      </div>
    </section>
  );
};

export default Mutui;
